export default __webpack_public_path__ + "static/media/MarketRealCase1.96f4aec4.jpg";